var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 530 385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0B2766",
    d: "M468.5,176.6c-8.9-5.5-18.1-11.1-27.2-16.6c-50.3-30.5-100-59.7-100-59.7s-36.1,47.2-71.9,95.1 c-5.7,7.6-11.3,15.2-16.9,22.6c-18.6,25.1-35.6,48.3-45.3,62.6c-8.4,12.2-20.7,31.3-34,52.4c-3.7,5.9-7.6,11.9-11.4,18 c-7.2,11.4-14.4,22.9-21.3,34H530V215.8C516,206.1,493.3,191.8,468.5,176.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#10243D",
    d: "M530,161.4V385H185.6c0-0.1,0-0.2-0.1-0.3c-3.9-16.5-8.1-34.3-12.4-51.7c-1-4.1-2-8.2-3-12.2 c-11.6-47.4-22.1-88.6-22.1-88.6s41.3-5.4,88.7-12c5.2-0.7,10.4-1.5,15.7-2.2c15.4-2.2,31.1-4.4,45.9-6.6 c25.4-3.8,48.1-7.3,62.3-10.1c15.4-3,39.3-8.4,65.5-14.6c13.8-3.3,28.2-6.7,42.4-10.2c6.2-1.5,12.3-3,18.3-4.5 C502.5,168.3,517.3,164.6,530,161.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#07142D",
    d: "M486.9,172.1c-14.8-5.5-30-9.6-45.5-12.1c-57.4-9.5-118.4,1.3-171.4,35.1c-0.2,0.1-0.3,0.2-0.5,0.3 c-11.7,7.5-22.6,15.8-32.5,24.8c-31,28-53.5,62.8-66.6,100.6c-3.5,9.9-6.3,20-8.4,30.2c-2.4,11.2-4,22.6-4.7,34H530V193.2 C516.3,184.7,501.8,177.7,486.9,172.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E1E2D",
    d: "M530,227.9V385H185.5c0-0.1,0-0.2,0-0.3c5.1-65.4,39.9-127.5,99.7-165.5c4.3-2.8,8.8-5.3,13.2-7.8 c40.4-21.9,84.9-29.7,127.8-24.6C463.4,191.1,499.4,205.1,530,227.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B2766",
    d: "M330.1,385H213.6c5.8-2.6,18-7.5,33.7-11.1C265.7,370.3,303.5,375.4,330.1,385z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B2766",
    d: "M297.8,240.4c0,0,19.8,6.6,37,22.2c22.9,20.2,51,94.7,35.7,110.8c-15.3,16.1-87.3-9.4-109.6-30 c-17.2-15.6-25.7-40.4-25.7-40.4s6.9-33.7,17.2-44.8C261.7,246.9,297.8,240.4,297.8,240.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B2766",
    d: "M463,214c0,0,14,14.9,12.9,37.5c-2.1,29.7-50.6,111.7-72.4,109.1c-21.8-2.6-38.7-89.7-35.9-119.8 c1.8-23.1,5.9-26.6,5.9-26.6s33.9-21.5,48.8-21C435.8,195.7,463,214,463,214z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B2766",
    d: "M530,258.7v113.2c-15.2,5.7-33.9,10.5-51,13.1h-39.4c-3.9-1.2-6.8-2.9-8.5-5.4c-12.2-17.8,42.7-91.1,67.2-108.5 C510.8,262.5,523.1,259.7,530,258.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D1B27",
    d: "M419,385h-39c3.5-6,6.9-12.5,12.7-13.4c6.9-0.7,14.3,1,21.1,5.8C417.2,379.8,418.5,382.3,419,385z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E1E2D",
    d: "M503.9,338.9c-2,1.2-65.9,40.1-66.8,38.8c-0.8-1.3,61.5-42.8,63.5-44c2-1.2,4.1-0.8,4.9,0.5 C506.8,336.1,505.9,337.6,503.9,338.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E1E2D",
    d: "M419,275.8c-0.5,2.1-13,75.9-14.1,75.7c-1.1-0.2,7.6-74.3,8.1-76.5c0.5-2.1,2-4,3.5-3.1 C418.5,270.6,419.1,273,419,275.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E1E2D",
    d: "M309.8,306.8c1.9,1.5,52.9,56,51.6,56.8c-1.3,0.8-54.5-51.3-55.8-53.2c-1.9-1.5-1.4-3.7-0.5-5.1 C305.8,304.8,307.9,305.2,309.8,306.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBg);
export default __webpack_public_path__ + "static/media/footer_bg.1167b7f359c89ea40be77501d5c9dbfe.svg";
export { ForwardRef as ReactComponent };